var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1361",
    "data-name": "Group 1361",
    transform: "translate(-652 -195)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1252",
    "data-name": "Rectangle 1252",
    width: 37,
    height: 37,
    transform: "translate(652 195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-chess-piece-4354049",
    d: "M265.114,94.155a.872.872,0,0,1-.871.871h-.871a.872.872,0,0,0-.871.871v3.486h15.687V95.9a.872.872,0,0,0-.871-.871h-.871a.872.872,0,0,1-.871-.871v-.871c-1.782-2.279-1.861-5.258-1.8-6.972h.489a1.308,1.308,0,1,0,0-2.615h-.183a2.61,2.61,0,0,0,2.6-2.353l.54-5.4h0a.872.872,0,0,0-.867-.959h-.78a.872.872,0,0,0-.871.871v1.307a1.307,1.307,0,0,1-2.614,0V75.853a.872.872,0,0,0-.871-.871h-1.743a.872.872,0,0,0-.871.871v1.307a1.307,1.307,0,0,1-2.614,0V75.853a.872.872,0,0,0-.871-.871h-.78a.872.872,0,0,0-.868.959l.54,5.4a2.61,2.61,0,0,0,2.6,2.353h-.183a1.308,1.308,0,0,0,0,2.615h.489c.064,1.714-.015,4.693-1.8,6.972Z",
    transform: "translate(400.171 126.326)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4b3c0969777703742372ab7441b20e0f.svg";
export { ForwardRef as ReactComponent };